import { mapState } from "vuex";
import buyer_dialog from "@/views/order/orderDialog/order";
import contract_sign from "@/views/order/orderDialog/contractSign.vue";
import tabPane from "./components/tab-pane/index.vue";
import { preOrdergenerate } from "@/views/order/common.js";

export default {
  components: {
    tabPane,
    buyer_dialog,
    contract_sign,
  },
  data() {
    return {
      loading: false,
      orderStatusTab: {},
      appid: 0,
      tabId: 0,
      platformType: "SC",
      searchForm: {
        orderTimeStart: "",
        orderTimeEnd: "",
        orderId: "",
        goodsName: "",
        shopName: "",
        nextSingleName: "",
        receiverName: "",
        pageSize: 10,
        pageNum: 1,
        platformType: "SC",
        orderStatus: "0",
        orderTimeInterval: [],
      },
      list: [],
      totalNum: 0,
      pageNum: 0,
      deliveryDialogVisible: false,
      buyerVoucherPicList: [],
      deliveryGoodsButton: {},
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
    purchaseAuthority: (state) => state.app.purchaseAuthority,
  }),
  created() {
    this.appid = this.$route.query.appid || 0;
    this.tabId = this.$route.query.tabId || 0;
    if (this.appid == 1) {
      this.searchForm.platformType = "";
      this.platformType = "";
    }
    this.searchForm.orderStatus = this.tabId;
    this.selOrderStatusByParam();
    this.searchForm.pageNum = 1;
    this.selBuyerOrderListByParam();
  },
  methods: {
    loadOrder() {
      this.searchForm.pageNum = 1;
      this.selBuyerOrderListByParam();
    },
    handleTabsClick() {
      this.searchForm.pageNum = 1;
      this.selBuyerOrderListByParam();
    },
    handleClick() {
      this.selBuyerOrderListByParam();
    },
    selOrderStatusByParam() {
      this.$store.dispatch("orderTo/index/selOrderStatusByParam", { platformType: this.platformType, isSeller: 0 }).then((res) => {
        this.orderStatusTab = res.data;
      });
    },
    selBuyerOrderListByParam() {
      this.loading = true;
      console.log("this.searchForm.orderTimeInterval", this.searchForm.orderTimeInterval);
      if (this.searchForm.orderTimeInterval && this.searchForm.orderTimeInterval.length > 0) {
        this.searchForm.orderTimeStart = this.searchForm.orderTimeInterval[0] || "";
        this.searchForm.orderTimeEnd = this.searchForm.orderTimeInterval[1] || "";
      }
      this.list = [];
      this.$store.dispatch("orderTo/index/selBuyerOrderListByParam", this.searchForm).then((res) => {
        this.list = res.data.list || [];
        this.list.forEach((item) => {
          this.$set(item, "orderButtonEntityList", item.orderBuyerButtonEntityList);
        });
        this.totalNum = parseInt(res.data.total);
        this.pageNum = parseInt(res.data.pageNum);
        this.loading = false;
      });
    },
    resetOrderList() {
      this.searchForm.orderTimeStart = "";
      this.searchForm.orderTimeEnd = "";
      this.searchForm.orderId = "";
      this.searchForm.goodsName = "";
      this.searchForm.shopName = "";
      this.searchForm.nextSingleName = "";
      this.searchForm.receiverName = "";
      this.searchForm.orderTimeInterval = [];
    },
    buttonSubmit(item, order) {
      console.log("buttonSubmit", item, order);
      switch (item.buttonCode) {
        case "to_multiple_pay_by_gray_setting":
          this.$message.error(item.buttonMsg);
          return;
        case "to_pay_juge_contract":
          this.$message.error(item.buttonMsg);
          return;
        case "to_multiple_pay_by_confirm":
          this.$message.error(item.buttonMsg);
          return;
        case "to_multiple_pay":
          window.open(`${process.env.VUE_APP_APP}order/person/toOrderFractionalPayment?orderId=${order.orderId}&type=1`);
          return;
        case "to_pay_by_gray_setting":
          this.$message.error(item.buttonMsg);
          return;
        case "to_pay_by_confirm":
          this.$message.error(item.buttonMsg);
          return;
        case "to_pay":
          this.selOrderToPayByOrderId(order.orderId);
          return;
        case "to_pay_by_finance":
          // https://jr.t.nxin.com/nfd/pc/sytpay/payContinue.shtml?orderNum=xxxx
          this.openOrderToPayBox("如果没弹出支付页面，可能被您的浏览器拦截了！请检查浏览器设置", "我已支付完成", "遇到问题，重试");
          window.open(`${process.env.VUE_APP_JR}nfd/pc/sytpay/payContinue.shtml?orderNum=${order.orderId}`);
          return;
        case "to_sign_contract":
          this.$store.dispatch("orderTo/index/signContract", { orderId: order.orderId }).then((res) => {
            if (res && res.code) {
              this.$refs.contract_sign_dialog.getContractData(order.orderId, false, { ...order, buildContractVisible: true }, true);
            } else {
              this.$message.error("订单:" + order.orderId + "，电子合同属性设置不完整，根据法律规定，无法签署合同，请完善电子合同属性后，再进行签署。");
            }
          });
          return;
        case "to_read_contract":
          this.$refs.contract_sign_dialog.viewContract(item);
          //window.open(`${process.env.VUE_APP_APP}contract/toEcontrantDetail?id=${item.contractId}&isBuyer=2`);
          return;
        case "to_sign_material":
          window.open(
            // eslint-disable-next-line max-len
            `${process.env.VUE_APP_APP}contract/toSignMaterialConfirmation?orderId=${order.orderId}&returnUrl=${window.location.href}`
          );
          return;
        case "to_read_material":
          window.open(
            // eslint-disable-next-line max-len
            `${process.env.VUE_APP_APP}contract/toMaterialConfirmationDetail?id=${order.orderId}&isBuyer=1`
          );
          return;
        case "to_cancel_by_confirm":
          this.$message.error(item.buttonMsg);
          return;
        case "to_cancel":
          this.$confirm("确定取消订单吗", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$store.dispatch("orderTo/index/cancelOrder", { orderId: order.orderId }).then((res) => {
                if (res.success) {
                  this.$message("取消成功");
                  this.selOrderStatusByParam();
                  this.selBuyerOrderListByParam();
                } else {
                  this.$message.error(res.errormsg);
                }
              });
            })
            .catch(() => {});
          return;
        case "to_order_del":
          this.$confirm("确定删除订单吗", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$store.dispatch("orderTo/index/delOrder", { orderId: order.orderId }).then((res) => {
                this.$message(res.message);
                this.selOrderStatusByParam();
                this.selBuyerOrderListByParam();
              });
            })
            .catch(() => {});
          return;
        case "to_buy_again":
          this.$store.dispatch("orderTo/index/orderBuyAgain", { orderId: order.orderId }).then((res) => {
            if (res && res.success) {
              if (res.errormsg) {
                this.$message.error(res.errormsg);
              }
              window.open(`${process.env.VUE_APP_APP}cart/selectCart`);
            } else if (res && res.errorcode && res.errorcode == "1000") {
              window.open(`${process.env.VUE_APP_WEB_QLW}appmrket/shopjump?t=p&id=${res.data}`);
            } else {
              this.$message.error(res.errormsg);
            }
          });
          return;
        case "to_apply_refund":
          this.$store.dispatch("orderTo/index/orderRefund", { orderId: order.orderId }).then((res) => {
            if (res.code == 0) {
              window.open(`${process.env.VUE_APP_APP}order/person/toApplyRefund?orderId=${order.orderId}`);
            } else {
              this.$message.error(res.msg);
            }
          });
          return;
        case "to_read_refund":
          window.open(
            // eslint-disable-next-line max-len
            `${process.env.VUE_APP_APP}v/aftersales/detail/${item.refundOrderId}?type=buyer&orderId=${order.orderId}`
          );
          return;
        case "to_remind_shipment":
          this.$store.dispatch("orderTo/index/orderRemindShipment", { orderId: order.orderId }).then(() => {
            this.$message("提醒发送成功");
          });
          return;
        case "to_delivery_goods":
          this.buyerVoucherPicList = [];
          if (order.buyerVoucherPicList.length == 0 && order.sellerVoucherPicList.length > 0) {
            order.sellerVoucherPicList.forEach((sellerVoucher) => {
              const voucher = {
                name: "",
                url: sellerVoucher.url || "",
              };
              this.buyerVoucherPicList.push(voucher);
            });
          }
          this.$refs.order_buyer_dialog.toDeliveryGoodsOpen(item, this.buyerVoucherPicList.length, this.buyerVoucherPicList, order.delivery);
          return;
        case "to_order_logistic":
          window.open(`${process.env.VUE_APP_APP}order/person/orderDeliver?orderId=${order.orderId}&type=1`);
          return;
        case "to_order_valuation":
          window.open(`${process.env.VUE_APP_APP}v/comment/add?isShowTitle=1&orderId=${order.orderId}`);
          return;
        case "to_order_review":
          window.open(`${process.env.VUE_APP_APP}v/comment/comment?isShowTitle=1&orderId=${order.orderId}`);
          return;
        case "to_order_edit_delivery_addr":
          this.$refs.order_buyer_dialog.toEditDelivery(order.orderId);
          return;
        case "to_order_edit_self_pickup_addr":
          this.$refs.order_buyer_dialog.toEditSelfPickupDelivery(order.orderId);
          return;
        case "to_behalf_purchase_pick_up_buyer":
          window.open(`${process.env.VUE_APP_APP}shopInfo/shopInfoList.do?shopId=${order.shopId}`);
          return;
        case "to_add_invoice_buyer":
          window.open(`${process.env.VUE_APP_APP}v/order/detail/${order.orderId}?showAddInvoice=true`);
          return;
        case "to_pick_up_yyd_buyer":
          preOrdergenerate(
            {
              cartItemReqFormList: order.orderGoodsBoList.map((item) => ({
                fromShopId: order.shopId,
                quantity: item.goodsQuantity,
                skuId: item.goodsId,
              })),
              vueThis: this,
              relationOrderId: order.orderId,
            }
          )
          return;
        default:
        this.$message.error("无效按钮");
        return;
      }
    },
    selOrderToPayByOrderId(orderId) {
      this.$store.dispatch("orderTo/index/selOrderToPayByOrderId", { orderId: orderId }).then((data) => {
        console.log("selOrderToPayByOrderId", data);
        if (!data.isAllowPayment) {
          this.$message.error("您没有支付权限");
          return;
        }
        // 签署代付协议
        if (data.isBuildPaymentOnBehalfTreaty == "1") {
          this.$confirm("您正在替其他用户或企业支付该笔订单，请签署相关代付协议后再支付？", "提示", {
            confirmButtonText: "签署",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.openOrderToPayBox("如果没弹出签署页面，可能被您的浏览器拦截了！请检查浏览器设置", "我已完成签署", "遇到问题，重试");
              window.open(`${process.env.VUE_APP_APP}v/treaty/paymentOnBehalfTreaty?isShowTitle=1&orderId=${orderId}`);
            })
            .catch(() => {});
          return;
        }
        // 个人认证
        if (data.isBuildPaymentOnBehalfTreaty == "2") {
          this.$confirm("您正在替其他用户或企业支付该笔订单，请先进行实名认证后再支付？", "提示", {
            confirmButtonText: "去认证",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.openOrderToPayBox("如果没弹出认证页面，可能被您的浏览器拦截了！请检查浏览器设置", "我已完成认证", "遇到问题，重试");
              window.open(`${process.env.VUE_APP_JR}yue_openAccount_auth.html?retUrl=${window.location.href}`);
            })
            .catch(() => {});
          return;
        }
        // 企业认证
        if (data.isBuildPaymentOnBehalfTreaty == "3") {
          this.$confirm("您正在替其他用户或企业支付该笔订单，请先进行实名认证后再支付？", "提示", {
            confirmButtonText: "去认证",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.openOrderToPayBox("如果没弹出认证页面，可能被您的浏览器拦截了！请检查浏览器设置", "我已完成认证", "遇到问题，重试");
              window.open(`${process.env.VUE_APP_JR}yueOrgRegister.html?retUrl=${window.location.href}`);
            })
            .catch(() => {});
          return;
        }
        if (data.isBuildPaymentOnBehalfTreaty == "4") {
          this.$message.error("下单用户或企业未完成实名认证，您无法替该用户或企业支付该笔订单");
          return;
        }

        if (!data.isToPay) {
          this.$message.error(data.isToPayMsg);
          return;
        }
        this.openOrderToPayBox("如果没弹出支付页面，可能被您的浏览器拦截了！请检查浏览器设置", "我已支付完成", "遇到问题，重试");
        window.open(`${process.env.VUE_APP_APP}payment/chectout/bkCheckout/${orderId}`);
      });
    },
    openOrderToPayBox(msg, confirmButtonText, cancelButtonText) {
      const h = this.$createElement;
      this.$msgbox({
        title: "消息",
        message: h("p", null, [h("span", null, msg)]),
        showCancelButton: true,
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            console.log("openOrderToPayBox", action);
          }
          done();
          this.searchForm.pageNum = 1;
          this.selBuyerOrderListByParam();
        },
      }).then(() => {});
    },
  },
};
